import { Condition } from "./enums";
import { IFilters } from "./filters";

export interface IConfig {
    default: IDefault;
    basemapLVM: IBasemapLVM;
    basemapOrto: IBasemapOrto;
    layers: ILayerConfig[];
    geoLocation?: ILocation;
    sideView: ISideView;
    dataView: IDataView;
    search: ISearch;
    reCaptchaSiteKey: string;
    upload: IUploadConfig;
    print: IPrintConfig;
    email: IEmailConfig;
}
export interface IDefault {
    center: number[];
    extentSize: number[];
    zoom: number;
    minZoom: number;
    projection: string;
    zoomToLevel: number;
    clusterLayerId: string;
    polygonLayerId: string;
    clusterDistance: number;
    polygonZoomThreshold: number;
    dataDownloadUrl: string;
}

export interface IBasemapLVM {
    tileGrid: {
        extent: number[];
        origin: number[];
        tileSize: number[];
        resolutions: number[];
    };
    source: {
        url: string;
        maxZoom: number;
        projection: string;
        crossOrigin: string;
    };
}
export interface IBasemapOrto {
    source: {
        url: string;
        params: {
            LAYERS: string;
            FORMAT: string;
            transparent: boolean;
        };
        projection: string;
        serverType: string;
        crossOrigin: string;
    };
}
export interface ILayerConfig {
    id: string;
    title: string;
    copyright: string;
    url: string;
    crossOrigin: string;
}
export interface ILocation {
    geolocationOptions?: {
        maximumAge: number;
        timeout: number;
        enableHighAccuracy: boolean;
    };
}

export interface IIdentify {
    fields: string[];
    conditionalFields: IIdentifyCondition[];
}

export interface IIdentifyCondition {
    field: string;
    value: string | number | boolean;
    condition: Condition;
    showFields: string[];
}
export interface IDataView {
    defaultHeightPx?: number;
    openButtonFieldName?: string;
    docsButtonFieldName?: string;
    applyButtonFieldName?: string;
    imageFieldName?: string;
    fallbackImageUrl?: string;
    thumbnailHeight?: number;
    tabLayerId: string;
    tabField: string;
    imageApi: string;
    docsApi: string;
    currencyFields: string[];
    tabs: IDataTab[];
}
export interface IDataTab {
    tabValue: string | number | boolean;
    showDocs?: boolean;
    showApply?: boolean;
    fields: string[];
    mobileUIFields: string[];
    preview: IPreview;
    identify: IIdentify;
}

export interface ISideView {
    textFilter: IFilterConfig;
    filters: IFilterConfig[];
}

export interface IPreview {
    fields: string[];
    hardcodedFields: IHardcodedField[];
    footerText: string;
}

export interface IHardcodedField {
    field: string;
    alias: string;
    values: string[];
}
export interface IFilterConfig {
    field: string;
    title: string;
    multipleSelection?: boolean;
}

export interface ISearch {
    fields: string[];
}

export interface IUploadConfig {
    url: string;
}

export interface IPrintConfig {
    endpoint: string;
    url: string;
}

export interface IEmailConfig {
    subject: string;
    body: string;
    url: string;
}

export const proxyUrl = process.env.NODE_ENV === "development" ? "https://lvmkartes.lvm.lv/noma/beta/" : "";
export const all = "visi";
export const defaultOption = { name: all, code: undefined };
export const objectIdGap = 10000000;

export const config: IConfig = {
    default: {
        center: [530000, 310000],
        extentSize: [530000, 310000],
        zoom: 4.5,
        minZoom: 3.5,
        projection: "EPSG:3059",
        zoomToLevel: 13,
        clusterLayerId: "clusterLayer",
        polygonLayerId: "polygonLayer",
        clusterDistance: 80,
        polygonZoomThreshold: 9.116829398696783,
        dataDownloadUrl: "https://www.lvmgeo.lv/dati"
    },
    basemapLVM: {
        tileGrid: {
            extent: [-1349424.723447654, -595003.4846995564, 2424864.0751299444, 1206812.6189326514],
            origin: [-5120900, 3998100],
            tileSize: [512, 512],
            resolutions: [
                1058.3354500042335, 529.1677250021168, 264.5838625010584, 132.2919312505292, 52.91677250021167,
                26.458386250105836, 13.229193125052918, 10.583354500042335, 7.9375158750317505, 5.291677250021167,
                3.9687579375158752, 2.6458386250105836, 1.3229193125052918, 0.5291677250021167
            ]
        },
        source: {
            url: proxyUrl + "proxy/D341478CE74F4F02B68607991448D499/CloudMap_mammadaba/MapServer/tile/{z}/{y}/{x}",
            maxZoom: 14,
            projection: "EPSG:3059",
            crossOrigin: "anonymous"
        }
    },
    basemapOrto: {
        source: {
            url: "https://lvmgeoserver.lvm.lv/geoserver/ows",
            params: {
                LAYERS: "public:Orto_LKS",
                FORMAT: "image/vnd.jpeg-png8",
                transparent: false
            },
            projection: "EPSG:3857",
            serverType: "geoserver",
            crossOrigin: "anonymous"
        }
    },
    layers: [
        {
            id: "cadaster",
            title: "Kadastra karte",
            copyright: "Valsts Zemes dienests",
            url: proxyUrl + "proxy/7cb29dcbb61442b7a22c289b22d671b8/MapServer",
            crossOrigin: "anonymous"
        },
        {
            id: "LAD",
            title: "Lauku atbalsta dienesta dati",
            copyright: "LAD",
            url: proxyUrl + "proxy/D341478CE74F4F02B68607991448D499/LAD/vLAD/MapServer",
            crossOrigin: "anonymous"
        },
        {
            id: "DAP",
            title: "Dabas aizsardzības pārvaldes dati",
            copyright: "DAP",
            url: proxyUrl + "proxy/D341478CE74F4F02B68607991448D499/DAP/vDAP_public/MapServer",
            crossOrigin: "anonymous"
        },
        {
            id: "melioracija",
            title: "ZMNĪ meliorācijas sistēmas",
            copyright: "ZMNĪ",
            url: proxyUrl + "proxy/D341478CE74F4F02B68607991448D499/CacheDinamic/ZMNI/MapServer",
            crossOrigin: "anonymous"
        }
    ],
    geoLocation: {
        geolocationOptions: {
            maximumAge: 0,
            timeout: 15000,
            enableHighAccuracy: true
        }
    },
    sideView: {
        textFilter: {
            field: "TEXT-FILTER",
            title: "Teksta meklēšana"
        },
        filters: [
            { field: "REGIONATVK", title: "Novads" },
            { field: "MUNICIPALITYATVK", title: "Pagasts" },
            { field: "LVMFORESTRYCODE", title: "LVM reģions" },
            { field: "RENTPURPOSE", title: "Iznomāšanas mērķis", multipleSelection: true },
            { field: "LANDAREA", title: "Platība, ha (diapazons)" },
            { field: "TYPEOFLEASEGRANTING", title: "Nomas tiesību piešķiršanas veids" }
        ]
    },
    dataView: {
        defaultHeightPx: 300,
        openButtonFieldName: "Atvērt sludinājumu",
        docsButtonFieldName: "Pievienotie dokumenti",
        applyButtonFieldName: "Pieteikties",
        imageFieldName: "Attēls",
        fallbackImageUrl: "https://www.lvmgeo.lv/themes/25-lvmgeo/images/header-logo.svg",
        thumbnailHeight: 200,
        tabLayerId: "landplotTest",
        tabField: "STATE",
        imageApi: proxyUrl + "proxy/fp_photo_01246833d064492b96b37d4a25d4049d",
        docsApi: proxyUrl + "proxy/fp_docs_c14406ff035c450ba1ac5025c614289d",
        currencyFields: ["STARTRENT", "TAX", "REGISTRATIONFEE", "RECOGNIZANCE", "AUCTIONEDRENT"],
        tabs: [
            {
                tabValue: 1,
                showDocs: true,
                showApply: true,
                fields: [
                    "OBJECTNAME",
                    "RENTPURPOSE",
                    "LANDAREA",
                    "AGREEMENTTERM",
                    "STARTRENT",
                    "FIRSTPUBLISHDATE",
                    "APPLICATIONENDDATE",
                    "TYPEOFLEASEGRANTING"
                ],
                mobileUIFields: ["OBJECTNAME", "STARTRENT", "LANDAREA", "RENTPURPOSE"],
                preview: {
                    fields: [
                        "LANDAREA",
                        "RENTPURPOSE",
                        "STARTRENT",
                        "TAX",
                        "AGREEMENTTERM",
                        "OBJECTDESCRIPTION",
                        "SPECIALCONDITIONS",
                        "hardcoded-OBJECTVISITING",
                        "hardcoded-CONTACTS",
                        "TYPEOFLEASEGRANTING",
                        "REGISTRATIONFEE",
                        "RECOGNIZANCE",
                        "APPLICATIONENDDATE",
                        "AUCTIONPLACES",
                        "EVENTDATE"
                    ],
                    hardcodedFields: [
                        {
                            field: "hardcoded-OBJECTVISITING",
                            alias: "Objekta apskates vieta un laiks",
                            values: ["Iepriekš vienojoties ar zemāk norādīto kontaktpersonu"]
                        },
                        {
                            field: "hardcoded-CONTACTS",
                            alias: "Kontakti",
                            values: ['AS "Latvijas valsts meži"', "EMPLOYEENAME", "EMPLOYEEEMAIL", "EMPLOYEEPHONE"]
                        }
                    ],
                    footerText:
                        "*Cenā nav iekļauts Nekustamā īpašuma nodoklis un Pievienotās vērtības nodoklis. Tie ir jāmaksā atbilstoši spēkā esošām nodokļu likmēm."
                },
                identify: {
                    fields: ["OBJECTNAME", "RENTPURPOSE", "LANDAREA", "AGREEMENTTERM", "TYPEOFLEASEGRANTING"],
                    conditionalFields: [
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "2",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "3",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "4",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "AUCTIONPLACES",
                            value: "ONLIN",
                            condition: Condition.Not,
                            showFields: []
                        }
                    ]
                }
            },
            {
                tabValue: 2,
                fields: [
                    "OBJECTNAME",
                    "RENTPURPOSE",
                    "LANDAREA",
                    "AGREEMENTTERM",
                    "FIRSTPUBLISHDATE",
                    "TYPEOFLEASEGRANTING"
                ],
                mobileUIFields: ["OBJECTNAME", "LANDAREA", "RENTPURPOSE"],
                preview: {
                    fields: [
                        "LANDAREA",
                        "RENTPURPOSE",
                        "STARTRENT",
                        "TAX",
                        "AGREEMENTTERM",
                        "OBJECTDESCRIPTION",
                        "SPECIALCONDITIONS",
                        "hardcoded-OBJECTVISITING",
                        "hardcoded-CONTACTS",
                        "REGISTRATIONFEE",
                        "RECOGNIZANCE",
                        "APPLICATIONENDDATE",
                        "AUCTIONPLACES",
                        "EVENTDATE"
                    ],
                    hardcodedFields: [
                        {
                            field: "hardcoded-OBJECTVISITING",
                            alias: "Objekta apskates vieta un laiks",
                            values: ["Iepriekš vienojoties ar zemāk norādīto kontaktpersonu"]
                        },
                        {
                            field: "hardcoded-CONTACTS",
                            alias: "Kontakti",
                            values: ['AS "Latvijas valsts meži"', "EMPLOYEENAME", "EMPLOYEEEMAIL", "EMPLOYEEPHONE"]
                        }
                    ],
                    footerText:
                        "*Cenā nav iekļauts Nekaustāmā īpašuma nodoklis un Pievienotās vērtības nodoklis. Tie ir jāmaksā atbilstoši spēkā esošām nodokļu likmēm."
                },
                identify: {
                    fields: ["OBJECTNAME", "RENTPURPOSE", "LANDAREA", "AGREEMENTTERM", "TYPEOFLEASEGRANTING"],
                    conditionalFields: [
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "2",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "3",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "4",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "AUCTIONPLACES",
                            value: "ONLIN",
                            condition: Condition.Not,
                            showFields: []
                        }
                    ]
                }
            },
            {
                tabValue: 3,
                fields: ["OBJECTNAME", "RENTPURPOSE", "LANDAREA", "STARTRENT", "AUCTIONEDRENT", "LEASEE"],
                mobileUIFields: ["OBJECTNAME", "AUCTIONEDRENT", "LANDAREA", "RENTPURPOSE"],
                preview: {
                    fields: [
                        "LEASEE",
                        "AUCTIONEDRENT",
                        "LANDAREA",
                        "RENTPURPOSE",
                        "STARTRENT",
                        "TAX",
                        "AGREEMENTTERM",
                        "OBJECTDESCRIPTION",
                        "SPECIALCONDITIONS",
                        "hardcoded-OBJECTVISITING",
                        "hardcoded-CONTACTS",
                        "REGISTRATIONFEE",
                        "RECOGNIZANCE",
                        "APPLICATIONENDDATE",
                        "AUCTIONPLACES",
                        "EVENTDATE"
                    ],
                    hardcodedFields: [
                        {
                            field: "hardcoded-OBJECTVISITING",
                            alias: "Objekta apskates vieta un laiks",
                            values: ["Iepriekš vienojoties ar zemāk norādīto kontaktpersonu"]
                        },
                        {
                            field: "hardcoded-CONTACTS",
                            alias: "Kontakti",
                            values: ['AS "Latvijas valsts meži"', "EMPLOYEENAME", "EMPLOYEEEMAIL", "EMPLOYEEPHONE"]
                        }
                    ],
                    footerText:
                        "*Cenā nav iekļauts Nekaustāmā īpašuma nodoklis un Pievienotās vērtības nodoklis. Tie ir jāmaksā atbilstoši spēkā esošām nodokļu likmēm."
                },
                identify: {
                    fields: ["OBJECTNAME", "RENTPURPOSE", "LANDAREA", "STARTRENT", "AUCTIONEDRENT"],
                    conditionalFields: [
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "2",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "3",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "4",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "AUCTIONPLACES",
                            value: "ONLIN",
                            condition: Condition.Not,
                            showFields: []
                        }
                    ]
                }
            },
            {
                tabValue: 4,
                fields: [
                    "OBJECTNAME",
                    "RENTPURPOSE",
                    "LANDAREA",
                    "AUCTIONEDRENT",
                    "LEASEE",
                    "CONTRACTDATE",
                    "CONTRACTENDDATE"
                ],
                mobileUIFields: ["OBJECTNAME", "AUCTIONEDRENT", "LANDAREA", "RENTPURPOSE"],
                preview: {
                    fields: [
                        "LEASEE",
                        "AUCTIONEDRENT",
                        "CONTRACTDATE",
                        "CONTRACTENDDATE",
                        "LANDAREA",
                        "RENTPURPOSE",
                        "STARTRENT",
                        "TAX",
                        "AGREEMENTTERM",
                        "OBJECTDESCRIPTION",
                        "SPECIALCONDITIONS",
                        "hardcoded-OBJECTVISITING",
                        "hardcoded-CONTACTS",
                        "REGISTRATIONFEE",
                        "RECOGNIZANCE",
                        "APPLICATIONENDDATE",
                        "AUCTIONPLACES",
                        "EVENTDATE"
                    ],
                    hardcodedFields: [
                        {
                            field: "hardcoded-OBJECTVISITING",
                            alias: "Objekta apskates vieta un laiks",
                            values: ["Iepriekš vienojoties ar zemāk norādīto kontaktpersonu"]
                        },
                        {
                            field: "hardcoded-CONTACTS",
                            alias: "Kontakti",
                            values: ['AS "Latvijas valsts meži"', "EMPLOYEENAME", "EMPLOYEEEMAIL", "EMPLOYEEPHONE"]
                        }
                    ],
                    footerText:
                        "*Cenā nav iekļauts Nekaustāmā īpašuma nodoklis un Pievienotās vērtības nodoklis. Tie ir jāmaksā atbilstoši spēkā esošām nodokļu likmēm."
                },
                identify: {
                    fields: [
                        "OBJECTNAME",
                        "RENTPURPOSE",
                        "LANDAREA",
                        "AUCTIONEDRENT",
                        "LEASEE",
                        "CONTRACTDATE",
                        "CONTRACTENDDATE"
                    ],
                    conditionalFields: [
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "2",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "3",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "TYPEOFLEASEGRANTING",
                            value: "4",
                            condition: Condition.Is,
                            showFields: []
                        },
                        {
                            field: "AUCTIONPLACES",
                            value: "ONLIN",
                            condition: Condition.Not,
                            showFields: []
                        }
                    ]
                }
            }
        ]
    },
    search: {
        fields: ["PROPERTYTITLE", "CADASTER", "OBJECTNAME", "SPECIALCONDITIONS"]
    },
    reCaptchaSiteKey: "6LffWbodAAAAAN9yurCV4D7GKyz82OxSyrZ5gEhw",
    upload: {
        url: proxyUrl + "proxy/fp_save_67312ef2b5244f28a6183e2397755e88/api/Save"
    },
    print: {
        endpoint: "/dipa/pdf",
        url: proxyUrl + "proxy/print_846d8f58c3da4f91bc914f7fca62d0ec"
    },
    email: {
        subject: "Nomas pieteikuma apstiprinājums",
        body: "AS “Latvijas valsts meži” Jūsu iesniegtais nomas pieteikums ir saņemts, par procesa tālāku virzību ar Jums sazināsies attiecīgā reģiona Nekustamo īpašumu pārvaldes zemes lietojuma speciālists.",
        url: proxyUrl + "proxy/email_4f7ad5fa1c62484cab58d7d64013f4aa/api/send"
    }
};

export const filterAllValues: IFilters = Object.assign(
    {},
    ...config.sideView.filters.map((filter) => ({
        [filter.field]: filter.field === "LANDAREA" ? [0, 0] : all
    }))
);
export const defaultFilterValues: IFilters = Object.assign(
    {},
    ...config.sideView.filters.map((filter) => ({
        [filter.field]: filter.field === "LANDAREA" ? [0, 0] : all
    }))
);
export const defaultWindFarmFilterValues: IFilters = Object.assign(
    {},
    ...config.sideView.filters.map((filter) => ({
        [filter.field]: filter.field === "LANDAREA" ? [0, 0] : filter.field === "RENTPURPOSE" ? [8] : all
    }))
);
